import React from 'react'

import { IconProps } from '../Types'

export const EyeOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="EyeOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m21.39,10.38c-.76-.84-2.03-2.09-3.62-3.13-1.59-1.04-3.58-1.92-5.77-1.92s-4.19.88-5.77,1.92c-1.59,1.04-2.85,2.29-3.61,3.12-.39.45-.61,1.03-.61,1.62s.22,1.17.61,1.62c.76.84,2.02,2.09,3.62,3.13,1.59,1.04,3.58,1.92,5.77,1.92s4.19-.88,5.77-1.92c1.59-1.04,2.85-2.29,3.61-3.12.39-.45.61-1.03.61-1.62s-.22-1.17-.61-1.62Zm-9.4,6.3c-1.69,0-3.31-.68-4.72-1.61-1.4-.92-2.54-2.03-3.24-2.8-.07-.08-.1-.18-.1-.28s.03-.2.1-.28c.7-.77,1.84-1.88,3.24-2.8,1.41-.93,3.03-1.61,4.72-1.61s3.31.68,4.72,1.61c1.4.92,2.54,2.03,3.24,2.8.07.08.1.18.1.28s-.03.2-.1.28c-.7.77-1.84,1.88-3.24,2.8-1.41.93-3.03,1.61-4.72,1.61Z"/><path d="m11.99,8.16c-2.08,0-3.76,1.72-3.76,3.84s1.69,3.84,3.76,3.84,3.76-1.72,3.76-3.84-1.69-3.84-3.76-3.84Zm0,5.68c-1,0-1.81-.82-1.81-1.85s.81-1.85,1.81-1.85,1.81.82,1.81,1.85-.81,1.85-1.81,1.85Z"/>',
    }}
  />
)

EyeOutline.displayName = 'EyeOutline'

export const tags = ['EyeOutline', '']
